import  get  from 'lodash/get'
import { getQueryVariable } from '../apiCalls/jobInfo';
import { getJobWheels } from './index';
import { STC_STATE_ARRAYS } from '../components/JobQueue/components/StcConstants';

export const getState = (state) => {
  let res = [];
  for (let key in states) {
    if (key === state) { res = [states[key].classname, states[key].border] }
  }
  return res;
}

export const mapStates = (states) => {
  let arr = [];
  for (let key in states) {
    arr.push(key)
  }
  return arr;
}

export const isFormEnabled = (currentJobData, kxUser) => {

  const isEngine = (sessionStorage.getItem('onlyOneShipment') == 'true' || getQueryVariable('onlyOneShipment'))
  const transCountry = getQueryVariable('transactionCountry')
  
  if (transCountry !== 'CA' && isEngine) {
    return true;
  }

  if (!currentJobData || (!kxUser && !(isEngine && transCountry === 'CA')) ) {
    return false;
  }

  const shipmentCountry = (window.shipmentCountry).toUpperCase();

  let isBrokerKnAdmin = get(kxUser, 'kxUserBasicInfo.typeOfUser', '') === 'BROKER_KN_ADMIN';

  if (shipmentCountry === 'US') {
    return true;
  }
  let jobWheel = getJobWheels(shipmentCountry, currentJobData);

  let entrySummaryState = get(jobWheel, "ES_JOB_WHEEL.value.state") || '';
  let cargoReleaseState = get(jobWheel, "CR_JOB_WHEEL.value.state");
  //let PscState = get(jobWheel, "PSC_JOB_WHEEL.value.state");
  let stcState = get(jobWheel, "STC_JOB_WHEEL.value.state");
  
  sessionStorage.setItem("entrySummaryState", entrySummaryState)
  sessionStorage.setItem("entrySummaryStateCr", cargoReleaseState)
  
  // Check STC state - form editable only in IN_PROCESS or IN_READY
  if (stcState) {
    if (!STC_STATE_ARRAYS.EDITABLE_STATES.includes(stcState)) {
      return false
    }
  }
  
  let brokerState = get(jobWheel, "BROKER_PROCESS.value.state");
  let brokerHouse = get(jobWheel, "SHIPMENT_BROKER_HOUSE_PROCESS.value.state");
  let userGuid = get(kxUser, 'userBasicInfo.userGuid', '');
  let brokerGuid = currentJobData.brokerGuid;

  if(shipmentCountry === 'US' && !entrySummaryState && !cargoReleaseState && !stcState && brokerHouse === 'STATE_BH_BROKER_IN_PROCESS'){
    return true;
  }

  if (userGuid !== brokerGuid && !(isEngine && transCountry === 'CA')) {
    return false;
  }
  if (brokerHouse === "STATE_BH_BROKER_DONE" || brokerHouse === "STATE_BH_ASSIGNED") {
    return false;
  }
  if (disableStateMapper.includes(brokerState)) {
    return false;
  }
  
  // If either is in editable state
  if ((shipmentCountry === 'US'|| transCountry === 'US') && [
    'STATE_ENTRY_SUMMARY_IN_PROCESS', 
    'STATE_ENTRY_SUMMARY_READY',
    'STATE_ENTRY_ACCOUNTING_IN_PROCESS', 
    'STATE_ENTRY_ACCOUNTING_READY', 
    "STATE_ENTRY_ACCOUNTING_AMEND_IN_PROCESS"
  ].includes(entrySummaryState)) {
    return true;
  }

  if ((shipmentCountry === 'CA' || transCountry === 'CA') && [
    'STATE_ENTRY_ACCOUNTING_IN_PROCESS',
    'STATE_ENTRY_ACCOUNTING_READY',
    "STATE_ENTRY_ACCOUNTING_AMEND_IN_PROCESS"
  ].includes(entrySummaryState) && currentJobData.parentShipmentId) {
    return true;
  }

   if ([
    'STATE_CARGO_RELEASE_IN_PROCESS', 
    'STATE_CARGO_RELEASE_READY',
  ].includes(cargoReleaseState)) {
    return true;
  } 
  //  if ([
  //   'STATE_PSC_IN_PROCESS',
  //   'STATE_PSC_READY'
  // ].includes(PscState)) {
  //   return true;
  // }

  if (shipmentCountry === 'CA' &&
    (cargoReleaseState.includes('FILED') ||
      cargoReleaseState.includes("READY") || // New
      cargoReleaseState.includes("REJECTED") ||
      cargoReleaseState.includes("CANCEL_ACCEPTED") ||
      entrySummaryState.includes("REJECTED") ||
      entrySummaryState.includes("READY") || // New
      entrySummaryState.includes("AMEND") ||
      (!editableStates[shipmentCountry][entrySummaryState] &&
        !editableStates[shipmentCountry][cargoReleaseState])
    )) {
    return false;
  }

  if (shipmentCountry === 'GB' && !editableStates[shipmentCountry][entrySummaryState]) {
    return false;
  }

  return true;
}

export const getUpdateType = (currentJobData, kxUser) => {
  if (!currentJobData || !kxUser) {
    return false;
  }
  const shipmentCountry = (window.shipmentCountry).toUpperCase();
  let jobWheel = getJobWheels(shipmentCountry, currentJobData);
  let entrySummaryState = get(jobWheel, "ES_JOB_WHEEL.value.state");
  let cargoReleaseState = get(jobWheel, "CR_JOB_WHEEL.value.state");
  let stcState = get(jobWheel, "STC_JOB_WHEEL.value.state");
  let esJobWheel = get(jobWheel, "ES_JOB_WHEEL");
  let crJobWheel = get(jobWheel, "CR_JOB_WHEEL");
  let pscState = get(jobWheel, "PSC_JOB_WHEEL.value.state");
  let brokerState = get(jobWheel, "BROKER_PROCESS.value.state");
  let brokerHouse = get(jobWheel, "SHIPMENT_BROKER_HOUSE_PROCESS.value.state");
  let userGuid = get(kxUser, 'userBasicInfo.userGuid', '');
  let brokerGuid = currentJobData.brokerGuid;
  
  // STC-only workflow (DHL): allow form editing only in IN_PROCESS or READY states
  if (stcState && !esJobWheel && !crJobWheel) {
    return !STC_STATE_ARRAYS.EDITABLE_STATES.includes(stcState);
  }
  if (!stcState && !esJobWheel && !crJobWheel && shipmentCountry == 'US' && brokerHouse == 'STATE_BH_BROKER_IN_PROCESS') {
    return false
  }
  if (userGuid !== brokerGuid) {
    return true;
  }
  if(["STATE_PSC_IN_PROCESS", "STATE_PSC_READY"].includes(pscState) ){
    return false
  }
  
  if (brokerHouse === "STATE_BH_BROKER_DONE" || brokerHouse === "STATE_BH_ASSIGNED") {
    return true;
  }
  let isEsEditable = editableStates[shipmentCountry][entrySummaryState];
  let isCrEditable = editableStates[shipmentCountry][cargoReleaseState];

  if (!disableStateMapper.includes(brokerState) && (isEsEditable || isCrEditable)) {
    // If only ES, then return entryUpdate
    if (isEsEditable && !isCrEditable) {
      return updateTypes.entryUpdate
    } else if (!isEsEditable && isCrEditable) {  // If only CR, then return cargoReleaseUpdate
      return updateTypes.cargoReleaseUpdate
    } else if (isEsEditable && isCrEditable) {
      return updateTypes.combined
    } else if (!isEsEditable && !isCrEditable) {
      return false
    }
  }
  return true
}

export const updateTypes = {
  combined: 'combined',
  entryUpdate: 'entryUpdate',
  cargoReleaseUpdate: 'cargoReleaseUpdate',
  docPgaCorrectionOption: 'docPgaCorrectionOption',
  cargoReleaseStandaloneUpdate: ' cargoReleaseStandaloneUpdate',
  //b3Review: 'b3Review'
}

export const filerEventMapper = {
  "US": {
    ["filerEvent"]: 'FILE_ENTRY_SUMMARY_FORM'
  },
  "GB": {
    ["filerEvent"]: 'FILE_C88_SUMMARY_FORM'
  },
  "ES": {
    ["filerEvent"]: 'FILE_C88_SUMMARY_FORM'
  },
  "CA": {
    ["filerEvent"]: 'FILE_CBSA_EDI_RECORDS'
  }
}

export const generatePdfTypeES = {
  "US": {
    "type": "CLIENT_PDF_ES"
  },
  "CA": {
    "type": "CLIENT_PDF_B3",
    "CARM": {
      "type": "CLIENT_PDF_CARM"
    }
  },
  "GB": {
    "type": "CLIENT_PDF_C88"
  },
  "ES": {
    "type": "CLIENT_PDF_C88"
  }
}

export const generatePdfTypeCR = {
  "US": {
    "type": "CLIENT_PDF_CR"
  },
  "CA": {
    "type": ""
  },
  "GB": {
    "type": ""
  },
  "ES": {
    "type": ""
  }
}

export const submitEventMapper = {
  "US": {
    ["submitEvent"]: 'SUBMIT_ENTRY_SUMMARY_FORM'
  },
  "CA": {
    ["submitEvent"]: 'REVIEW_CBSA_EDI_RECORDS'
  },
  "GB": {
    ["submitEvent"]: 'SUBMIT_C88_SUMMARY_FORM'
  },
  "ES": {
    ["submitEvent"]: 'SUBMIT_C88_SUMMARY_FORM'
  }
}

export const disableStateMapper = [
  "STATE_BROKER_IN_QUEUE",
  "STATE_CHECKPOINT_FAILED"
];

export const lockedNctsStateMapper = [
  "STATE_TRANSIT_NONE",
  "STATE_TRANSIT_PENDING"
]

export const lockedEUStateMapper = [
  "STATE_ENTRY_NONE",
  "STATE_ENTRY_NEW"
]

export const submitLabelMapper = {
  //[updateTypes.combined]: 'ES & CR FINAL REVIEW',
  "US": {
    [updateTypes.combined]: 'FINAL REVIEW',
    [updateTypes.entryUpdate]: 'ES FINAL REVIEW',
    [updateTypes.cargoReleaseUpdate]: 'CR FINAL REVIEW'
  },
  "CA": {
    [updateTypes.combined]: 'IID REVIEW',
    [updateTypes.entryUpdate]: 'B3 REVIEW',
    [updateTypes.cargoReleaseUpdate]: 'IID REVIEW'
  },
  "GB": {
    [updateTypes.combined]: 'C88 REVIEW',
    [updateTypes.entryUpdate]: 'C88 REVIEW',
    [updateTypes.cargoReleaseUpdate]: 'C88 REVIEW'
  },
  "ES": {
    [updateTypes.combined]: 'C88 REVIEW',
    [updateTypes.entryUpdate]: 'C88 REVIEW',
    [updateTypes.cargoReleaseUpdate]: 'C88 REVIEW'
  },
}

export const resettingJobEventMapper = {
  "US": {
    ["resetJobEvent"]: 'UPDATE_ENTRY_SUMMARY_STATE'
  },
  "CA": {
    ["resetJobEvent"]: 'UPDATE_CBSA_EDI_RECORD'
  },
  "GB": {
    ["resetJobEvent"]: 'UPDATE_C88_FORM_STATE'
  },
  "ES": {
    ["resetJobEvent"]: 'UPDATE_C88_FORM_STATE'
  },
}

export const resettingJobDocType = {
  "US": {
    [updateTypes.combined]: 'DOC_ENTRY_7501',
    [updateTypes.entryUpdate]: 'DOC_ENTRY_7501_NON_COMBINED',
    [updateTypes.cargoReleaseUpdate]: 'DOC_ENTRY_3461',
    [updateTypes.docPgaCorrectionOption]: 'DOC_PGA_UPDATE',
    [updateTypes.cargoReleaseStandaloneUpdate]: 'DOC_ENTRY_3461',

  },
  "CA": {
    [updateTypes.combined]: 'DOC_ENTRY_7501',
    [updateTypes.entryUpdate]: 'DOC_ENTRY_7501_NON_COMBINED',
    [updateTypes.cargoReleaseUpdate]: 'DOC_ENTRY_3461'
  },
  "GB": {
    [updateTypes.combined]: 'DOC_ENTRY_7501',
    [updateTypes.entryUpdate]: 'DOC_ENTRY_7501',
    [updateTypes.cargoReleaseUpdate]: 'DOC_ENTRY_7501'
  },
  "ES": {
    [updateTypes.combined]: 'DOC_ENTRY_7501',
    [updateTypes.entryUpdate]: 'DOC_ENTRY_7501',
    [updateTypes.cargoReleaseUpdate]: 'DOC_ENTRY_7501'
  }
}

const rejectedStates = {
  "US": {
    STATE_CARGO_RELEASE_REJECTED: true,
    STATE_ENTRY_SUMMARY_REJECTED: true
  },
  "CA": {
    STATE_CARGO_RELEASE_REJECTED: true,
    STATE_CARGO_RELEASE_CANCEL_REJECTED:true,
    STATE_ENTRY_ACCOUNTING_REJECTED: true,
    STATE_ENTRY_ACCOUNTING_AMEND_REJECTED: true,
    STATE_ENTRY_ACCOUNTING_CANCEL_REJECTED: true,
  },
  "GB": {
    STATE_ENTRY_REJECTED: true
  },
  "ES": {
    STATE_ENTRY_REJECTED: true
  },
  "NL": {
    STATE_ENTRY_REJECTED: true
  }
}

const acknowledgedStates = {
  "US": {
    STATE_CARGO_RELEASE_ACKNOWLEDGED: true,
    STATE_ENTRY_SUMMARY_ACKNOWLEDGED: true
  },
  "CA": {
    STATE_CARGO_RELEASE_ACKNOWLEDGED: true,
    STATE_ENTRY_ACCOUNTING_ACKNOWLEDGED: true
  },
  "GB": {
    STATE_ENTRY_SUMMARY_ACKNOWLEDGED: true
  },
  "ES": {
    STATE_ENTRY_SUMMARY_ACKNOWLEDGED: false
  }
}

const editableStates = {
  "US": {
    STATE_ASSIGNED_TO_BROKER: true,
    STATE_ENTRY_SUMMARY_NONE: true,
    STATE_ENTRY_SUMMARY_IN_PROCESS: true,
    STATE_ENTRY_SUMMARY_ON_HOLD: true,
    STATE_ENTRY_SUMMARY_READY: true,
    STATE_CARGO_RELEASE_IN_PROCESS: true,
    STATE_CARGO_RELEASE_READY: true,
    STATE_CARGO_RELEASE_ON_HOLD: true,
    STATE_CARGO_RELEASE_NONE: true,
  },
  "GB": {
    STATE_ENTRY_NONE: true,
    STATE_ENTRY_ASSIGNED: true,
    STATE_ENTRY_IN_PROCESS: true,
    STATE_ENTRY_ON_HOLD: true,
    STATE_ENTRY_READY: true,
    STATE_ENTRY_AMEND_IN_PROCESS: true,
    STATE_ENTRY_AMEND_READY: true,
  },
  "ES": {
    STATE_ENTRY_NONE: true,
    STATE_ENTRY_ASSIGNED: true,
    STATE_ENTRY_IN_PROCESS: true,
    STATE_ENTRY_ON_HOLD: true,
    STATE_ENTRY_READY: true,
    STATE_ENTRY_AMEND_IN_PROCESS: true,
    STATE_ENTRY_AMEND_READY: true,
  },
  "NL": {
    STATE_ENTRY_NONE: true,
    STATE_ENTRY_IN_PROCESS: true,
    STATE_ENTRY_ON_HOLD: true,
    STATE_ENTRY_READY: true,
    STATE_ENTRY_AMEND_IN_PROCESS: true,
    STATE_ENTRY_AMEND_READY: true,
  },
  "CA": {
    STATE_ENTRY_ACCOUNTING_NONE: true,
    STATE_CARGO_RELEASE_NONE: true,
    STATE_ASSIGNED_TO_BROKER: true,
    STATE_ENTRY_ACCOUNTING_IN_PROCESS: true,
    STATE_ENTRY_ACCOUNTING_AMEND_IN_PROCESS: true,
    STATE_ENTRY_ACCOUNTING_ON_HOLD: true,
    STATE_ENTRY_ACCOUNTING_READY: true,
    STATE_ENTRY_ACCOUNTING_AMEND_READY: true,
    STATE_ENTRY_ACCOUNTING_STUCK: true,
    STATE_CARGO_RELEASE_IN_PROCESS: true,
    STATE_CARGO_RELEASE_ON_HOLD: true,
    STATE_CARGO_RELEASE_READY: true,
    STATE_CARGO_RELEASE_CANCEL_ACCEPTED: true, 
  }
}

export const completeStates = {
  "US": {
    STATE_ENTRY_SUMMARY_ACCEPTED: true,
    STATE_ENTRY_SUMMARY_ACCEPTED_WITH_WARNINGS: true,
    STATE_CARGO_RELEASE_ACCEPTED: true,
    STATE_CARGO_RELEASE_ACCEPTED_WITH_WARNINGS: true,
    STATE_ENTRY_SUMMARY_REJECTED: true,
    STATE_CARGO_RELEASE_REJECTED: true
  },
  "CA": {
    STATE_ENTRY_ACCOUNTING_ACCEPTED: true,
    STATE_ENTRY_ACCOUNTING_REJECTED: true,
    STATE_ENTRY_ACCOUNTING_CANCEL_REJECTED: true,
    STATE_ENTRY_ACCOUNTING_AMEND_ACCEPTED: true,
    STATE_ENTRY_ACCOUNTING_AMEND_REJECTED: true,
    STATE_CARGO_RELEASE_ACCEPTED: true,
    STATE_CARGO_RELEASE_REJECTED: true,
    STATE_CARGO_RELEASE_CANCEL_REJECTED: true,
    STATE_CARGO_RELEASE_ACKNOWLEDGED: true,
    STATE_CARGO_RELEASE_ACCEPTED_WITH_WARNINGS: true,
    STATE_RNS_MESSAGE_CONTENT_ACCEPTED: true,
    STATE_RNS_MESSAGE_CONTENT_REJECTED: true,
    STATE_RNS_GOODS_RELEASED: true,
    STATE_RNS_GOODS_REQUIRED_FOR_EXAMINATION_REFERRED: true,
    STATE_RNS_GOODS_MAY_MOVE_DETAIN_TO_DESTINATION: true,
    STATE_RNS_DECLARATION_ACCEPTED_AWAITING_ARRIVAL_OF_GOODS: true,
    STATE_RNS_DECLARATION_ACCEPTED_AWAITING_CUSTOMS_PROCESSING: true,
    STATE_RNS_ERROR_MESSAGE: true,
    STATE_RNS_AUTHORISED_TO_DELIVER_CSA_SHIPMENT: true,
  },
  "GB": {
    STATE_ENTRY_ACCEPTED: true,
    STATE_ENTRY_FEC_FAILED: true,
    STATE_ENTRY_REJECTED: true,
    STATE_ACCEPTED_ENTRY_ROUTE_0: true,
    STATE_ACCEPTED_ENTRY_ROUTE_1_C: true,
    STATE_ACCEPTED_ENTRY_ROUTE_1: true,
    STATE_ACCEPTED_ENTRY_ROUTE_2: true,
    STATE_ACCEPTED_ENTRY_ROUTE_2_C: true,
    STATE_ACCEPTED_ENTRY_ROUTE_3: true,
    STATE_ACCEPTED_ENTRY_ROUTE_3_C: true,
    STATE_ACCEPTED_ENTRY_ROUTE_5: true,
    STATE_ACCEPTED_ENTRY_ROUTE_6: true,
    STATE_ACCEPTED_ENTRY_ROUTE_6_C: true,
    STATE_ACCEPTED_ENTRY_ROUTE_E: true,
    STATE_ACCEPTED_ENTRY_ROUTE_F: true,
    STATE_ACCEPTED_ENTRY_ROUTE_H: true
  },
  "ES": {
    STATE_ENTRY_ACCEPTED: true,
    STATE_ENTRY_REJECTED: true,
  },
  "NL": {
    STATE_ENTRY_ACCEPTED: true,
    STATE_ENTRY_REJECTED: true,
  }

}

export const successfulSubmitKeys = {
  'Cargo Release  was saved successfully': true,
  'Entry Summary data was saved successfully': true,
  "C88 Form Submitted Successfully": true,
  "Update cargo release was filed successfully": true,
}

export const filedStates = {
  "US": {
    STATE_ENTRY_SUMMARY_FILED: true,
    STATE_ENTRY_SUMMARY_RETRACT_FILED: true,
    STATE_CARGO_RELEASE_FILED: true,
    STATE_CARGO_RELEASE_RETRACT_FILED: true,
    STATE_PSC_FILED: true,
  },
  "CA": {
    STATE_ENTRY_ACCOUNTING_CANCEL_FILED: true,
    STATE_ENTRY_ACCOUNTING_CANCEL_ACCEPTED: true,
    STATE_ENTRY_ACCOUNTING_CANCEL_REJECTED: true,
    STATE_ENTRY_ACCOUNTING_FILED: true,
    STATE_CARGO_RELEASE_FILED: true,
    //STATE_CARGO_RELEASE_RETRACT_FILED: true,
    STATE_CARGO_RELEASE_CANCEL_FILED: true,
    STATE_ENTRY_ACCOUNTING_CHANGE_FILED: true,
    STATE_ENTRY_ACCOUNTING_CHANGE_ACCEPTED: true,
    STATE_ENTRY_ACCOUNTING_CHANGE_REJECTED: true,
    STATE_ENTRY_ACCOUNTING_AMEND_FILED: true,
  },
  "GB": {
    STATE_ENTRY_FILED: true,
    STATE_ENTRY_AMEND_FILED: true
  },
  "ES": {
    STATE_ENTRY_FILED: true,
    STATE_ENTRY_AMEND_FILED: true,
    STATE_ENTRY_CANCELLED_FILED: true
  },
  "NL": {
    STATE_ENTRY_FILED: true,
    STATE_ENTRY_AMEND_FILED: true
  }

}

export const cancellationUKStates = {
  "US": {

  },
  "CA": {

  },
  "ES": {

  },
  "GB": {
    STATE_CANCEL_FILED: true,
    STATE_CANCEL_ACKNOWLEDGED: true,
    STATE_CANCEL_REJECTED: true,
    STATE_CANCEL_ACCEPTED: true,
  }

}
export const retractableStates = {
  "US": {
    STATE_ENTRY_SUMMARY_ACCEPTED: true,
    STATE_ENTRY_SUMMARY_ACCEPTED_WITH_WARNINGS: true,
    STATE_ENTRY_SUMMARY_RETRACT_REJECTED: true,
    STATE_CARGO_RELEASE_ACCEPTED: true,
    STATE_CARGO_RELEASE_ACCEPTED_WITH_WARNINGS: true,
    STATE_CARGO_RELEASE_REJECTED: true,
    STATE_CARGO_RELEASE_RETRACT_REJECTED: true
  },
  "CA": {

  },
  "GB": {

  },
  "ES": {

  },
  "NL": {

  }


}
export const states = {
  JOB_STATE_NONE: {
    classname: 'white',
    border: 'white',
  },
  STATE_CARGO_RELEASE_NONE: {
    classname: 'white',
    border: 'white',
  },

  JOB_STATE_CARGO_RELEASE_ASSIGNED: {
    classname: 'white',
    border: '#23B80B',
  },
  STATE_CARGO_RELEASE_IN_PROCESS: {
    classname: 'white',
    border: '#23B80B',

  },
  STATE_CARGO_RELEASE_STUCK: {
    classname: 'white',
    border: '#f15c22',
  },
  STATE_CARGO_RELEASE_READY: {
    classname: 'white',
    border: '#23B80B',
  },
  STATE_CARGO_RELEASE_FILED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_CARGO_RELEASE_ACCEPTED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_CARGO_RELEASE_ACCEPTED_WITH_WARNINGS: {
    classname: 'yellow',
    border: '#F5A623',
  },
  STATE_CARGO_RELEASE_REPLACE_FILED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_CARGO_RELEASE_REPLACE_ACCEPTED: {
    classname: 'green',
    border: '#23B80B',
  },
  JOB_STATE_CARGO_RELEASE_REPLACED_ACCEPTED_WITH_WARNINGS: {
    classname: 'yellow',
    border: '#F5A623',
  },
  STATE_CARGO_RELEASE_REPLACE_REJECTED: {
    classname: 'red',
    border: '#f15c22',
  },
  STATE_CARGO_RELEASE_REJECTED: {
    classname: 'red',
    border: '#f15c22',
  },
  STATE_CARGO_RELEASE_RETRACT_FILED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_CARGO_RELEASE_RETRACT_ACCEPTED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_CARGO_RELEASE_RETRACT_REJECTED: {
    classname: 'red',
    border: '#f15c22',
  },
  STATE_BROKER_IN_QUEUE: {
    classname: 'white',
    border: '#23B80B',
  },
  STATE_ASSIGNED_TO_BROKER: {
    classname: 'white',
    border: '#23B80B',
  },
  // }

  // const stateMapperES = {
  // ISF
  STATE_ENTRY_SUMMARY_NONE: {
    classname: 'white',
    border: 'white',
  },

  JOB_STATE_ENTRY_SUMMARY_ASSIGNED: {
    classname: 'white',
    border: '#23B80B',
  },
  STATE_ENTRY_SUMMARY_IN_PROCESS: {
    classname: 'white',
    border: '#23B80B',
  },
  STATE_ENTRY_SUMMARY_STUCK: {
    classname: 'white',
    border: '#f15c22',
  },
  STATE_ENTRY_SUMMARY_READY: {
    classname: 'white',
    border: '#23B80B',
  },
  STATE_ENTRY_SUMMARY_FILED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_ENTRY_SUMMARY_ACCEPTED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_ENTRY_SUMMARY_ACCEPTED_WITH_WARNINGS: {
    classname: 'yellow',
    border: '#F5A623',
  },
  STATE_ENTRY_SUMMARY_REPLACE_FILED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_ENTRY_SUMMARY_REPLACE_ACCEPTED: {
    classname: 'green',
    border: '#23B80B',
  },
  JOB_STATE_ENTRY_SUMMARY_REPLACED_ACCEPTED_WITH_WARNINGS: {
    classname: 'yellow',
    border: '#F5A623',
  },
  STATE_ENTRY_SUMMARY_REPLACE_REJECTED: {
    classname: 'red',
    border: '#f15c22',
  },
  STATE_ENTRY_SUMMARY_REJECTED: {
    classname: 'red',
    border: '#f15c22',
  },
  STATE_ENTRY_SUMMARY_RETRACT_FILED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_ENTRY_SUMMARY_RETRACT_ACCEPTED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_ENTRY_SUMMARY_RETRACT_REJECTED: {
    classname: 'red',
    border: '#f15c22',
  },
  STATE_BROKER_IN_QUEUE: {
    classname: 'white',
    border: '#23B80B',
  },
  STATE_ASSIGNED_TO_BROKER: {
    classname: 'white',
    border: '#23B80B',
  },
  // }

  // const stateMapperCBPPayment = {
  STATE_CBP_FEE_NONE: {
    classname: 'white',
    border: 'white',
  },
  STATE_CBP_FEE_STARTED: {
    classname: 'white',
    border: '#23B80B',
  },
  STATE_CBP_FEE_DECLINED: {
    classname: 'red',
    border: '#f15c22',
  },
  STATE_CBP_FEE_ERROR: {
    classname: 'yellow',
    border: '#F5A623',
  },
  STATE_CBP_FEE_DONE: {
    classname: 'green',
    border: '#23B80B',
  },


  //BROKER
  STATE_BROKER_FEE_NONE: {
    classname: 'white',
    border: 'white',
  },
  STATE_BROKER_FEE_CR_ACCEPTED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_BROKER_FEE_ES_ACCEPTED: {
    classname: 'green',
    border: '#23B80B',
  },
  STATE_BROKER_FEE_STARTED: {
    classname: 'white',
    border: '#23B80B',
  },
  STATE_BROKER_FEE_DECLINED: {
    classname: 'red',
    border: '#f15c22',
  },
  STATE_BROKER_FEE_ERROR: {
    classname: 'yellow',
    border: '#F5A623',
  },
  STATE_BROKER_FEE_DONE: {
    classname: 'green',
    border: '#23B80B',
  },

  //OTHER
  STATE_OTHER_CBP_FEE_NONE: {
    classname: 'white',
    border: 'white',
  },
  STATE_OTHER_CBP_FEE_STARTED: {
    classname: 'white',
    border: '#23B80B',
  },
  STATE_OTHER_CBP_FEE_DECLINED: {
    classname: 'red',
    border: '#f15c22',
  },
  STATE_OTHER_CBP_FEE_ERROR: {
    classname: 'yellow',
    border: '#F5A623',
  },
  STATE_OTHER_CBP_FEE_DONE: {
    classname: 'green',
    border: '#23B80B',
  },
}

export const uatFileLabelMapper = {
  'US': 'FILE TO UAT',
  'CA': 'FILE CBSA UAT',
  'GB': 'FILE WITH HMRC',
  'ES': 'FILE WITH SPAIN GATEWAY'
}



export const UPDATELabelMapper = {
  'US': 'UPDATE',
  'CA': 'UPDATE IID',
  'UK': 'UPDATE',
  'ES': 'UPDATE'
}


export const ukRoutingStates = [
  "STATE_ACCEPTED_ENTRY_ROUTE_0",
  "STATE_ACCEPTED_ENTRY_ROUTE_1",
  "STATE_ACCEPTED_ENTRY_ROUTE_1_C",
  "STATE_ACCEPTED_ENTRY_ROUTE_2",
  "STATE_ACCEPTED_ENTRY_ROUTE_2_C",
  "STATE_ACCEPTED_ENTRY_ROUTE_3",
  "STATE_ACCEPTED_ENTRY_ROUTE_3_C",
  "STATE_ACCEPTED_ENTRY_ROUTE_5",
  "STATE_ACCEPTED_ENTRY_ROUTE_6",
  "STATE_ACCEPTED_ENTRY_ROUTE_6_C",
  "STATE_ACCEPTED_ENTRY_ROUTE_E",
  "STATE_ACCEPTED_ENTRY_ROUTE_F",
  "STATE_ACCEPTED_ENTRY_ROUTE_H"]

export const jobStatesService = {
  filedStates,
  completeStates,
  editableStates,
  rejectedStates,
  acknowledgedStates,
  retractableStates,
  uatFileLabelMapper,
  ukRoutingStates
}